import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppearQuizComponent } from '../appear-quiz/appear-quiz.component';
import { CreateQuizComponent } from '../create-quiz/create-quiz.component';


// IMPORT LEARNER MODULE COMPONENTS
import { MainQuizComponent } from './main-quiz.component';

const routes: Routes = [
  {
    path: '',
    component: MainQuizComponent,
    children: [
      {
        path: 'create-quiz',
        component: CreateQuizComponent
      },
      {
        path: 'appear-quiz',
        component: AppearQuizComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainQuizRoutingModule { }
